import React from 'react';
import PropTypes from 'prop-types';

import './carouselItem.less';

//width below accommodates 4 book jackets (inc. landscape) within 710px carousel
const CarouselItemWidth = '150px';

const CarouselItem = (props) => {
	const style = { 
		width: props.itemWidth || CarouselItemWidth,
		height: props.itemHeight
	};

	return <div className="carousel-item" style={style}>{props.children}</div>;
};

CarouselItem.propTypes = {
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
	itemWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

CarouselItem.defaultProps = {
	itemHeight: '220px'
}

export default CarouselItem;
export { CarouselItemWidth };


// WEBPACK FOOTER //
// ./src/react/views/carousel/CarouselItem.jsx